import React from 'react';
import InvoiceProvider from 'components/Tvendo/Shopping/Operations/Invoices/InvoiceProvider';

export default function () {
  return <InvoiceProvider />;
}
